<template lang="pug">
v-card.pa-4(:to="to", max-width="300px", width="100%")
  div
    v-icon.mt-n1(color="primary", small, left) fas fa-circle
    span.font-weight-bold.text-uppercase.text-body-1.grey--text.text--darken-3(
      v-html="title"
    )
  div
    v-icon(small, left) fas fa-calendar-day
    span {{ formatDate(date) }}
  div
    v-icon(small, left) fas fa-map-marker-alt
    span {{ local }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    local: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatDate(v) {
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(new Date(v));
    },
  },
};
</script>

<style>
.schedule-card-decoration {
  height: 18px;
  min-width: 18px;
  margin-top: 2px;
}
</style>
